<template>
    <div id="skuPage">
        <div style="position: fixed;background: rgba(0, 0, 0, .075);width: 100%;height: 100%;z-index: 999" v-if="isBtnajax">
            <a-spin style="transform:translate(-50%,-50%);position: absolute;top: 50%; left: 50%;"/>
        </div>

        <div v-if="skuLoading">
            <a-spin :spinning="skuLoading">
                <a-skeleton active />
            </a-spin>
        </div>
        <div v-else class="skupage" >
            <a-row style="display: flex;">
                <!--左侧查询开始-->
                <a-col :style="{width: showCondition ? conditionWidth+'px' : '0',marginRight: showCondition ? '10px' : '0',transition: 'width 0.1s linear'}">
                    <condition-query
                            ref="refConditionQuery"
                            :gmcUid="tableGmcuid"
                            :skuTableColumns="SkuTableColumns"
                            :aRowSeveralColumns="2"
                            :conditionWidth="400"
                            @showConQuery="showCondition = $event"
                            @conWidth="conWidth => conditionWidth = conWidth"
                            @conList="conditionList = $event,queryByCondition = true,initRenderFn()"/>
                </a-col>
                <!--左侧查询结束-->
                <a-col :style="{width: showCondition ? 'calc(100% - '+conditionWidth+'px)' : '100%'}">
                    <table-coms
                            v-if="data.tableList != undefined"
                            :tableData="SkuTableData"
                            :cols="SkuTableColumns"
                            :key="substr"
                            :fixedNum="fixedNum"
                            v-on:rederSub="GetrederSub"
                            :checkboxFlag="true"
                            v-on:selectRowData="getSelectDataTop"
                            v-on:checkBoxSelectData="getBoxSelectData"
                            :loading="parloading"
                            ref="tablsRef"
                            :setGmcuid="tableGmcuid"
                            :subParAnsear="true"
                            v-on:renderSearchVal="getredSearchVal"
                            v-on:renderSortVal="getrenderSortVal"
                            v-on:renderQueryVal="getrenderQueryVal"
                            :MaxHeight="MaxHeight"
                            v-on:clearConditionQuery="clearConditionQuery"
                            v-on:showNotification="showNotification"
                    >
                        <template slot="topTopFunction" v-if="this.soStatusButton.length > 0">
                            <div style="justify-content: space-between;width: calc(100% - 10px);align-items: center;height:50px;line-height: 50px;">
                                <a-button size="small" :key="item.code"
                                          v-for="item in soStatusButton"
                                          class="statusButton" @click="initByStatus(item.code)">{{item.codeDesc}}</a-button>
                            </div>
                        </template>

                        <template slot="topFunction">
                            <div style="display: flex;justify-content: space-between;width: calc(100% - 10px);margin-bottom: 5px;align-items: center;"><div>
                        <span style="float: left;margin-top: 6px;">
                             <function-bar
                                     @handleToolClick="handleToolClick"
                                     :buttonsObj="data.functionBtn"
                             ></function-bar>
                        </span>
                                <span style="float: left;margin-left: 4px;margin-top: 6px;">
                                 <a-icon type="search" style="margin-right: 4px;"/>
                          <a-select style="width: 180px" size="small" @change="skuTableTemplateData" v-model="parTableTemplateName" placeholder="Please select template">
                               <a-select-option value="all">all</a-select-option>
                          <a-select-option
                                  :key="item"
                                  :value="item"
                                  v-for="item in parTableTemplateSelect"
                          >{{ item }}</a-select-option>
                          </a-select>
                        </span>
                                </div>

                                <div style="margin-top: 6px;">
                                    <a-pagination
                                            :pageSizeOptions="pageSizeOptions"
                                            :showTotal="total => `${$t('generic.totalOf')} ${pagingTotal} ${$t('generic.Records')}`"
                                            size="small"
                                            :total="pagingTotal"
                                            v-model="currentVal"
                                            :pageSize.sync="pagingSize"
                                            @change="tableChangePage"
                                            @showSizeChange="onShowSizeChange"
                                            showSizeChanger

                                    />
                                </div>
                            </div>
                        </template>
                    </table-coms>
                </a-col>
            </a-row>
        </div>
        <tabs-table
                v-if="data.tabs != undefined"
                :tabsData="data.tabs"
                :targetUID="targetUID"
                :showTitleValue="showTitleValue"
                :parTabelEditVerSion = "parTabelEditVerSion"
                :tabsActive="tabsActive"
                ref="tabsTable"
                 :notShowEditPageSaveBtn="notShowEditPageSaveBtn"
        ></tabs-table>
        <edit-from
                :QueryUpdatas="QueryUpdatas"
                :visible="eddvisible"
                v-on:cancelModalVisible="GETcancelModalVisible"
                :apiType="apiType"
        ></edit-from>
       <import-modal
                 ref="importModal"
                :visible="importVisible"
                v-on:cancelImport="GETcancelImport"
                :importparams="importparams"
        ></import-modal>

        <popup-single
                ref="popupSingleRef"
                :QueryUpdatas="QueryUpdatas"
        ></popup-single>
        <generate-location
                ref="generateLocationRef"
                v-on:generatelocation="getGeneratelocation"
        ></generate-location>
        <create-wave ref="createWaveRef"></create-wave>
        <bath-update
                ref="bathUpdateRef"
                v-on:cancelModalVisible="GETcancelModalVisible"
        ></bath-update>
        <scanpack ref="scanpackRefs"></scanpack>

        <delivery-date ref="deliveryDate" v-on:deliverdate="getdeliverdate"></delivery-date>
 
        <liquor-step1 ref="liquorStepRef" v-on:refreshSo="this.init"></liquor-step1>
        <non-mer-main ref="nonMerMailRef" v-on:refreshSo="this.init"></non-mer-main>
		 <sku-info-search ref="skuSearch"  v-on:cancelImport="GETcancelImport"></sku-info-search>
        <store-arrival-excel ref="storeArrivalExcelRef"></store-arrival-excel>
        <kate-spade-excel ref="kateSpadeExcel" @showExcelErrorMsgBox="showExcelErrorMsgBox"  v-on:cancelImport="GETcancelImport" ></kate-spade-excel>
        <scan-pack-move ref="scanPackMove" ></scan-pack-move>
      <scan-pack-pick-to-zero ref="scanPackPickToZeroRef" ></scan-pack-pick-to-zero>
         <add-so-to-wave
                :visible="addSoToWaveVisible"
                v-on:cancelImport="waveCancelOrClosePop"
                :importparams="addSoToWaveRelIdList"
        ></add-so-to-wave>
        <import-scanning-file ref="importScanningFile" v-on:cancelImport="GETcancelImport"></import-scanning-file>
        <shipment-maintenance ref="refShipmentMaintenance"></shipment-maintenance>
        <assign-pickLoc-to-user ref="assignPickLocToUser"></assign-pickLoc-to-user>
        <create-dhl-shipment-id ref="createDhlShipmentId"></create-dhl-shipment-id>
        <add-order-to-shipment-id ref="addOrderToShipmentId"></add-order-to-shipment-id>
        <group-wave ref="groupWave" @routerWavePage="routerWavePage"></group-wave>
        <change-wh-project ref="changeWhProjectRef" v-on:success="initRenderFn"></change-wh-project>
    </div>
</template>
<script>
    import functionBar from "./components/functionBar.vue";
    import tabsTable from "./components/tabsTable.vue";
    import editFrom from "./components/editFrom.vue";
    import importModal from "./components/importModal.vue";
    import popupSingle from "./components/popupSingle.vue";
    import generateLocation from "./custPage/generateLocation.vue";
    import createWave from "./custPage/createWave.vue";
    import bathUpdate from "./custPage/bathUpdate.vue";
    import scanpack from "./custPage/scanpack.vue";
    import scanPackPickToZero from "./custPage/scanPackPickToZero.vue";
    import skuInfoSearch from './custPage/skuInfoSearch.vue'
    import deliveryDate from './custPage/deliverydate.vue'
    import liquorStep1 from "./sellLiquor/liquorStep1.vue" // 卖酒的
    import storeArrivalExcel from "./custPage/importStoreArrivalExcel.vue";
    import kateSpadeExcel from "./custPage/importKateSpadeExcel.vue";
    import scanPackMove from './custPage/scanPackMove.vue'
    import tableComs from "../com/tableComs.vue";
    import ajax from "../../api/ajax";
    import api from "../../api/url";
    import { mapState } from "vuex";
    import axios from "axios";
    import cookie from "../../api/cookie";
    import moment from "moment";
    import shipmentMaintenance from "./custPage/shipmentMaintenance";
    import addSoToWave from "./components/addSoToWave.vue";
    import NonMerMain from "./sellLiquor/nonMerMain";
    import importScanningFile from "./custPage/importScanningFile.vue";
    import assignPickLocToUser from "./custPage/assignPickLocToUser.vue";
    import createDhlShipmentId from "./custPage/createDhlShipmentId.vue";
    import addOrderToShipmentId from "./custPage/addOrderToShipmentId.vue";
    import groupWave from "./custPage/groupWave.vue";
    import changeWhProject from "./custPage/changeWhProject.vue";
    import conditionQuery from "../com/conditionQuery";

    export default {
        components: {
            tableComs,
            importModal,
            functionBar,
            tabsTable,
            editFrom,
            popupSingle,
            generateLocation,
            createWave,
            bathUpdate,
            scanpack,
            deliveryDate,
            liquorStep1,
            skuInfoSearch,
            storeArrivalExcel,
            scanPackMove,
            shipmentMaintenance,
            addSoToWave,
            importScanningFile,
            NonMerMain,
            assignPickLocToUser,
            createDhlShipmentId,
            addOrderToShipmentId,
            kateSpadeExcel,
            groupWave,
            conditionQuery,
            scanPackPickToZero,
            changeWhProject
        },

        computed: {
            ...mapState(["FUNAPI"]),
            ...mapState(["lang"]),
            ...mapState(["systemParam"]),

        },
        data() {
            return {
                addSoToWaveRelIdList:[],
                addSoToWaveVisible: false,
                notShowEditPageSaveBtn : false,
                tabsActive: '0',
                showTitleValue: [],
                lookupParams: {},
                pageSizeOptions:['10', '20', '30', '40','100','200','500','1000'],
                parTableTemplateSelect:[],
                parTabelEditVerSion: null,
                skuLoading: true,
                options: {
                    condition: [],
                    fieldNameSel: []
                },
                isFirst: true,
                fixedNum: 0, // 需要固定
                substr: 0, // 更新组件下标
                targetUID: null, // 点击表格转给弹窗uid
                tableGmcuid: "", // 后台返回GMUID
                pagingTotal: 0, // 总数
                pagingSize: Number.parseInt(sessionStorage.getItem('pageSize') || '30'), // 条数
                currentVal: 1, // 页数
                pageInfoType: "", // 分页查询条件
                customStyle: "border: 0;overflow: hidden",
                pb_selectList: [], // 表格check选中
                soUrl: [], // cfsShipment show url
                parloading: true, // 夫加载
                eddvisible: false,
                QueryUpdatas: {},
                apiType: "",
                funApi: "",
                strsub: 1,
                importVisible: false,
                TitleSearchVal: [], // 表格title search 条件
                importparams: {}, // 传个iport 参数
                manualParams: {}, // 转个manual 参数
                bathUpdatparams: {},
                initRenderFnSearchParamsArr: {
                    SortValArr: [],
                    titleSearchArr: [],
                    andvanSearchArr: {}
                },
                MaxHeight: 0,
                parTableTemplateName: undefined,
                SkuTableData: [],
                SkuTableColumns: [],
                isBtnajax: false,
                data: {}, // 表格数据
                orderStatus:"",
                soStatusButton:[],
                filterOneSkuOneQtyOrderFlag:false,
                showCondition:false,
                conditionList:[],
                conditionWidth:0,
                queryByCondition:false,
            };
        },
//  inject: ["reload"],
        created() {
            this.MaxHeight = document.body.clientHeight - 160;
            this.init("empty_temp")
        },
        methods: {
            showNotification(uid){
                this.$emit('showNotification',uid,"SO");
            },
            routerWavePage(waveUids){

                let userMenuJson = JSON.parse(sessionStorage.getItem("userMenuJson"));
                let menuLevel_2 = null;
                for(let i in userMenuJson){
                    if(userMenuJson[i].funcCode == 'M_OUTB'){
                        menuLevel_2 = userMenuJson[i].children
                        break;
                    }
                }

                if (menuLevel_2 != null){
                    for(let i in menuLevel_2){
                        if(menuLevel_2[i].funcCode == 'M_OUTB_WAVE'){
                            menuLevel_2[i].importUids = waveUids
                            this.$emit("updatePanes",  menuLevel_2[i]);
                            break;
                        }
                    }
                }
            },
            showExcelErrorMsgBox(errorMessage){
                this.$refs.importModal.showErrorMsgBox(errorMessage)
            },
            cleardata(){
                this.data = []
                this.init()
            },
            skuTableTemplateData(val){
                this.clearConditionQuery()

                this.orderStatus = '';
                this.clearImportUids();
                 this.parTableTemplateName  = val
                this.parloading = true;
                let jsonArray = {};
                jsonArray.gmcUid = this.tableGmcuid;
                this.pageInfoType = "qf";
                this.currentVal = 1;
                this.initRenderFnSearchParamsArr.andvanSearchArr = jsonArray;
                this.initRenderFn();
            },
            getTemplateName(){
                ajax.get(api.ADVANCETEMPLATE, { gmcUid: this.tableGmcuid }).then(res => {
                    this.parTableTemplateSelect = res.data
                    // if(this.parTableTemplateSelect.length> 0){
                    //     this.parTableTemplateName = this.parTableTemplateSelect[0]
                    // }
                });
            },
            //      generatelocation 返回的值刷新init
            getGeneratelocation() {
                this.init();
            },
            //      sort
            getrenderSortVal(paramsArr) {
                this.parloading = true;
                this.pageInfoType = "sort";
                this.currentVal = 1;
                this.initRenderFnSearchParamsArr.SortValArr = paramsArr;
                this.initRenderFn();
            },
            //      titleSearch
            getredSearchVal(val) {
                this.TitleSearchVal = val;
                let scParams = [];
                let tt = JSON.parse(JSON.stringify(val))
                tt.forEach((v, i) => {
                    if(v.type == "Datetime"){
                        if(v.serVal){
                            v.serVal = moment(v.serVal).format('YYYY-MM-DD HH:mm:ss')
                        }
                    }
                    if (v.type == "Date") {
                        if(v.serVal){
                            v.serVal =  moment(v.serVal).format('YYYY-MM-DD')
                        }
                    }
                    if (v.serVal) {
                        if( Array.isArray(v.serVal)){
                            for(let i in v.serVal){
                                scParams.push({ key: v.uid, value: v.serVal[i] });
                            }
                        }else{
                            scParams.push({ key: v.uid, value: v.serVal });

                        }
                    }
                });
                this.pageInfoType = "tle";
                this.currentVal = 1;
                this.initRenderFnSearchParamsArr.titleSearchArr = scParams;
                // this.initRenderFnSearchParamsArr.andvanSearchArr = [];
                this.initRenderFn();
            },

            //      query filter提交
            getrenderQueryVal(item) {
                this.orderStatus = '';
                this.clearImportUids()
                this.parloading = true;
                let jsonArray = item.query;
                jsonArray.gmcUid = this.tableGmcuid;
                  let templateName  = item.tml
                if(templateName != undefined && templateName != null){
                  this.parTableTemplateName  = templateName 
                }                      
                this.pageInfoType = "qf";
                this.currentVal = 1;
                this.initRenderFnSearchParamsArr.andvanSearchArr = jsonArray;
                this.initRenderFnSearchParamsArr.titleSearchArr = [];
                this.initRenderFn();
            },
            //      选择条数
            onShowSizeChange(current, pageSize) {
                this.currentVal = current;
                this.pagingSize = pageSize;
                 this.initRenderFn();
            },
            //      表格分页
            tableChangePage(current) {
                this.currentVal = current;
                 this.initRenderFn();
            },
            //      何在一起三个
            initRenderFn() {
                this.$nextTick(()=>{
                    this.parloading = true;
                    let params = {
                        functionUid: this.$route.query.funcUid,
                        gmcUid: this.tableGmcuid,
                        language: this.lang,
                        userUid: this.$route.query.userUid,
                        paging: {
                            pageNum: this.currentVal,
                            pageSize: this.pagingSize
                        }
                    };


                    if (this.pageInfoType == "sort") {
                        params.userSortDtos = this.initRenderFnSearchParamsArr.SortValArr;
                    } else if (this.pageInfoType == "tle") {
                        params.columnSearch = this.initRenderFnSearchParamsArr.titleSearchArr;
                        this.orderStatus = null;
                        this.clearImportUids();
                    } else if (this.pageInfoType == "qf") {
                        params.userSqlDto = this.initRenderFnSearchParamsArr.andvanSearchArr;
                        params.userSqlDto.template = this.parTableTemplateName
                        this.clearImportUids();
                    }
                    if(this.orderStatus != null && this.orderStatus != '') {
                        params.columnSearch = null;
                        params.userSqlDto = {};
                        params.userSqlDto.template = this.parTableTemplateName;
                        params.userSqlDto.orderStatus = this.orderStatus;
                        this.clearImportUids();
                    }
                    params.filterOneSkuOneQty = this.filterOneSkuOneQtyOrderFlag;

                    if(this.showCondition && this.queryByCondition){
                        if(this.conditionList.length > 0){
                            params.columnSearch = this.conditionList
                        }else {
                            params.columnSearch = []
                        }
                        this.initRenderFnSearchParamsArr.titleSearchArr = params.columnSearch
                        let jsonArray = {};
                        jsonArray.gmcUid = this.tableGmcuid;
                        this.initRenderFnSearchParamsArr.andvanSearchArr = jsonArray;
                        params.userSqlDto = undefined
                    }

                    //                sesstion 有importUid 加上这个参数
                    let topMenu = JSON.parse(sessionStorage.getItem("menu"))
                    let topMenuActive = sessionStorage.getItem("menuActive")
                    for(let i in topMenu){
                        if(topMenu[i].key == topMenuActive){
                            if(topMenu[i].importUids){
                                params.importUids = topMenu[i].importUids
                            }
                            if(topMenu[i].skuInfo){
                                params.skuInfo = topMenu[i].skuInfo
                            }
                        }
                    }

                    ajax.post(api.SKUS, params).then(res => {
                        this.filterOneSkuOneQtyOrderFlag = false;
                        if (res.code == 200) {
  				            	this.parloading = false;
                               if(res.data.tableList.paging != null){
                                  this.pagingTotal = res.data.tableList.paging.totalPageSize;
                               }   
            
				            	this.substr = this.substr + 1;      
                               this.data.tableList.data = res.data.tableList.data;
                               this.data.tableList.columns = res.data.tableList.columns;
                               this.SkuTableData = res.data.tableList.data;
                               this.SkuTableColumns = res.data.tableList.columns
                        } else {
                            this.$customMessage.warning(res.msg, 3);
                        }
                    });
                })
            },
            //      获取初始化数据
            init(type) {

			          this.initRenderFnSearchParamsArr.SortValArr= []
                      this.initRenderFnSearchParamsArr.titleSearchArr = []
                      this.initRenderFnSearchParamsArr.andvanSearchArr = {}


                // this.parTableTemplateName = undefined
                if (type == "editok") {
                    this.initRenderFn();
                }
                this.skuLoading = true;
                this.funApi = this.$route.query.funApi;
                if (this.funApi == "") {
                    return;
                }
                this.currentVal = 1;
                let params = {
                    userUid: this.$route.query.userUid,
                    functionUid: this.$route.query.funcUid,
                    language: this.lang,
                    pageNum: this.currentVal,
                    pageSize: this.pagingSize
                };

                if( "empty_temp" != type ){
                        let templateName = this.parTableTemplateName;
                        if(templateName == null || templateName == undefined){
                             this.parTableTemplateName = type
                            templateName = type;
                        }
                         this.pageInfoType = "qf"
                         params.userSqlDto = {};
                         params.userSqlDto.template = templateName;
                         params.isLoadAllConfig = false;
                }else{
                        this.parTableTemplateName = undefined
                }  

                this.pb_selectList = [];
                if(params.userUid == undefined && params.functionUid == undefined){
                    this.$customMessage.warning(this.$t('publicLang.IncorrectConfiguration'), 3)
                }
                //                sesstion 有importUid 加上这个参数
                let topMenu = JSON.parse(sessionStorage.getItem("menu"))
                let topMenuActive = sessionStorage.getItem("menuActive")
                for(let i in topMenu){
                    if(topMenu[i].key == topMenuActive){
                        if(topMenu[i].importUids){
                            params.importUids = topMenu[i].importUids
                        }

						    if(topMenu[i].skuInfo){
                            params.skuInfo = topMenu[i].skuInfo
                        }
                        break;
                    }
                }
                ajax.get(this.funApi, params).then(res => {
                    this.skuLoading = false;
                    if (res.code == 200) {
                        if(res.data.tableList.paging != null){
                            this.pagingTotal = res.data.tableList.paging.totalPageSize;
                        }
                        this.parloading = false;
                        this.substr = this.substr + 1;
                        this.SkuTableColumns = res.data.tableList.columns
                        this.SkuTableData = res.data.tableList.data


                       if( "empty_temp" == type ){
                             this.data = res.data;
                             this.tableGmcuid = res.data.gmcUid;
                             this.getTemplateName()
                            for(let i in this.SkuTableColumns){
                                if(this.SkuTableColumns[i].type == 'DROP'){
                                    this.SkuTableColumns[i].serVal = []
                                }
                             }

                           
                            for (let i in this.data.functionBtn) {
                                 let tt = this.data.functionBtn[i].children;
                                 for (let j in tt) {
                                     if (tt[j].code == "BTN_EDIT") {
                                         tt[j].editFlag = "1";

                                     }
                                 }
                             }
                          
                             for(let i in this.data.tabs){
                                 if( this.data.tabs[i].loadable == '1'){
                                     this.tabsActive = i
                                 }
                             }
                         }
                    } else {
                        this.data = [];
                        this.$customMessage.error(res.msg);
                    }
                });


                // Tom 2024-07-08 根据系统参数显示状态按钮
                let params2 = {
                    type: 'SO'
                };
                ajax.post(api.GENERICGETSTATUSBUTTONBYPAGE, params2).then(res => {
                    if (res.code === 200) {
                        if(res.data != undefined && res.data != null) {
                            this.soStatusButton = res.data;
                            // Tom 2024-07-10 codeMaster有配置 表格高度减小
                            if(this.soStatusButton != undefined && this.soStatusButton.length > 0) {
                                this.MaxHeight = document.body.clientHeight - 200;
                            } else {
                                this.MaxHeight = document.body.clientHeight - 160;
                            }
                        }
                    }
                });

            },
            //            清楚缓存中的ImportUids
            clearImportUids(){
                let topMenu = JSON.parse(sessionStorage.getItem("menu"))
                let topMenuActive = sessionStorage.getItem("menuActive")
                for(let i in topMenu){
                    if(topMenu[i].key == topMenuActive){
                        if(topMenu[i].importUids){
                            delete topMenu[i].importUids
                        }
						
						if(topMenu[i].skuInfo){
                            delete topMenu[i].skuInfo
                        }
                    }
                }
                sessionStorage.setItem("menu", JSON.stringify(topMenu));
            },
            //    操作固定width 需要重新渲染组件
            GetrederSub(val) {
                this.fixedNum = val;
                this.substr = this.substr + 1;
            },
            //      点击表格组件返回的当条数据，传给弹窗
            getSelectDataTop(val) {
                this.showTitleValue = []
                let arrFn = this.data.functionBtn;
                let tt = 0
                for (let i in arrFn){
                    for(let t in arrFn[i].children){
                        if(arrFn[i].children[t].code == 'BTN_EDIT'){
                            if(arrFn[i].children[t].pattern.custPage == "Putaway" && arrFn[i].children[t].type == "BUTTON"){
                                let paramsData = [];
                                let paramsObj = {}
                                paramsObj.key = "uid";
                                paramsObj.value = val.uid;
                                paramsData.push(paramsObj)
                                let edit = {
                                    behrUid: val.btnUid,
                                    userUid: this.$route.query.userUid,
                                    functionUid: this.$route.query.funcUid,
                                    params: paramsData,
                                    language: this.lang
                                }
                                this.$refs.adjustMove.show('Putaway',val.edit)
                                return
                            }
                            if(arrFn[i].children[t].pattern.custPage == "move" && arrFn[i].children[t].type == "BUTTON"){
                                this.$refs.adjustMove.show('moveGener',val.uid)
                                return
                            }
                            tt = tt + 1
                        }
                    }
                }
                
                 if(tt == 0){
                             this.notShowEditPageSaveBtn = true;
                  }
                      let tabs = this.data.tabs
                 if( this.data.editBtnInfo == null ||  this.data.editBtnInfo.gmcUid == null ){
                    return
                  }
             
                this.tabsActive = '0'
                for(let i in tabs){
                    if(tabs[i].loadable == '1'){
                        this.tabsActive = i
                    }
                }
                this.$store.commit("updataPartStatus", { partStatus: val.status });
                this.$refs.tabsTable.setPageType('SO')
                if(val.uid == this.targetUID){
                    this.$refs.tabsTable.showDawer()
                    return
                }
//      this.$refs.tabsTable.showDawer(val.version);
                this.targetUID = val.uid;
                if(val.showTitleValue.length > 0){
                    this.showTitleValue = val.showTitleValue
                }else{
                    this.showTitleValue = []
                }
                this.parTabelEditVerSion = val.version
            },
            //      获取表格checkbox
            getBoxSelectData(val) {
                this.pb_selectList = val;
            },
//            pdf 成功下载方法
            pubPdfUploadOk(data){
                this.isBtnajax = false
                this.$store.commit("updataLoading", { pbLoading: false });
                let blob = new Blob([data.data], {type: "application/pdf;charset=utf-8"});
                let url = window.URL.createObjectURL(blob);
                window.open(url);
            },
            // paf接口返回值处理
            pubPdfMsgfn(res){
                let data = res.data;
                let fileReader = new FileReader();
                let that = this
                fileReader.onload = function() {
                    try {
                        let jsonData = JSON.parse(this.result);
                        if (jsonData.code) {
                            that.$customMessage.warning(jsonData.msg);
                            that.$store.commit("updataLoading", { pbLoading: false });
                            that.isBtnajax = false
                        }
                    } catch (err) {
                        that.pubPdfUploadOk(res)
                    }
                };
                fileReader.readAsText(data)
            },
            //      功能
            handleToolClick(val) {
                if (val.code === "BTN_UPDATE") {
                    if (this.pb_selectList.length < 1) {
                        this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 3);
                        return;
                    }
                    let that = this;
                    this.$customConfirm({
                        title: that.$t('publicLang.AreUpadte'),
                        content: "",
                        onOk() {
                            that.isBtnajax = true
                            let deleteData = that.pb_selectList;
                            let paramsData = [];
                            for (let index in deleteData) {
                                if (deleteData[index].uid != "") {
                                    let paramsObj = {};
                                    paramsObj.key = "uid";
                                    paramsObj.value = deleteData[index].uid;
                                    paramsData.push(paramsObj);
                                    paramsData.push({
                                        key: "version",
                                        value: deleteData[index].version
                                    });
                                }
                            }
                            let params = {
                                behrUid: val.btnUid,
                                userUid: that.$route.query.userUid,
                                functionUid: that.$route.query.funcUid,
                                gmcUid: val.pattern.gmcUid,
                                params: paramsData,
                                type: "update",
                                language: that.lang
                            };

                            ajax.post(api.UPDATE, params).then(res => {
                                that.isBtnajax = false
                                if (res.code === 200) {
                                    that.$message.success(res.msg);
                                    that.initRenderFn();
                                    that.pb_selectList = [];
                                } else {
                                    that.$customConfirm({
                                        title: res.msg,
                                        okText: "Yes",
                                        okType: "confirm",
                                        cancelText: "No",
                                        onOk() {
                                            that.initRenderFn();
                                        }
                                    });
                                }
                            });
                        }
                    });
                }
                if (val.code == "BTN_REFRESH") {
                    this.clearImportUids()
                    this.orderStatus = '';
                    this.init("all");
                }
                //        添加
                if (val.code === "BTN_ADD") {
                    if(val.pattern.custPage == "Putaway" && val.type == "BUTTON"){
                        this.$refs.adjustMove.show('Putaway')
                        return
                    }
                    if(val.pattern.custPage == "lpnprint" && val.type == "BUTTON"){
                        this.$refs.lpnPrintRef.show()
                        return
                    }

                    let params = {
                        gmcUid: val.pattern.gmcUid,
                        language: this.lang
                    };
                    ajax.post(api.POPUP, params).then(res => {
                        this.apiType = "add";
                        this.QueryUpdatas = res;
                        this.QueryUpdatas.behrUid = val.btnUid;
                        this.QueryUpdatas.lookupCode = val.code;
                        this.QueryUpdatas.lookupGmcuid = val.pattern.gmcUid;
                        this.eddvisible = true;
                    });
                }
                //        编辑
                if (val.code === "BTN_EDIT") {
                    this.isBtnajax = true
                    if (this.pb_selectList.length != 1) {
                        this.$customMessage.warning(this.$t('publicLang.pleaseOneOnly'), 3)
                        this.isBtnajax = false
                        return;
                    } else {
                        this.QueryUpdatas = {};
                        let paramsData = [];
                        let dataValues = this.pb_selectList[0];
                        let params = {
                            gmcUid: val.pattern.gmcUid,
                            dataUid: dataValues.uid,
                            language: this.lang
                        };
                        this.eddvisible = true;
                        ajax.post(api.POPUP, params).then(res => {
                            this.QueryUpdatas = res;
                            this.isBtnajax = false
                            this.QueryUpdatas.behrUid = val.btnUid;
                            this.QueryUpdatas.lookupCode = val.code;
                            this.QueryUpdatas.lookupGmcuid = val.pattern.gmcUid;
                            this.apiType = "edit";
                        });
                    }
                }
                //        删除
                if (val.code === "BTN_DELETE") {
                    if (this.pb_selectList.length < 1) {
                        this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 3)
                        return;
                    }
                    let tt = [];
                    for (let ii in this.pb_selectList) {
                        if (!this.pb_selectList[ii].deletable) {
                            tt.push(this.pb_selectList[ii].key + 1);
                        }
                    }
                    if (tt.length > 0) {
                        let cc;
                        cc = tt.join(",");
                        this.$customMessage.warning(
                            "[Row#"+cc+']'+this.$t('publicLang.NotAllowtodeleteCancel'),
                            5
                        );
                        return;
                    }
                    let that = this;
                    this.$customConfirm({
                        title: this.$t('pubGicSet.AreyoudeleTask'),
                        okText: this.$t('publicLang.Confirm'),
                        cancelText: this.$t('publicLang.Cancel'),
                        content: "",
                        onOk() {
                            that.isBtnajax = true
                            let deleteData = that.pb_selectList;
                            let paramsData = [];
                            for (let index in deleteData) {
                                if (deleteData[index].uid != "") {
                                    let paramsObj = {};
                                    paramsObj.key = "uid";
                                    paramsObj.value = deleteData[index].uid;
                                    paramsData.push(paramsObj);
                                    paramsData.push({
                                        key: "version",
                                        value: deleteData[index].version
                                    });
                                }
                            }
                            let params = {
                                behrUid: val.btnUid,
                                userUid: that.$route.query.userUid,
                                functionUid: that.$route.query.funcUid,
                                gmcUid: val.pattern.gmcUid,
                                params: paramsData,
                                type: "delete",
                                language: that.lang
                            };

                            ajax.post(api.UPDATE, params).then(res => {
                                that.isBtnajax = false
                                if (res.code === 200) {
                                  that.pb_selectList = [];
                                  that.initRenderFn();
                                  that.$message.success(that.$t("publicLang.DeleteSuccess"));
                                } else {
                                  that.$customMessage.error(res.msg);
                                }
                            });
                        }
                    });
                }
                //        copy
                if (val.code == "BTN_COPY") {
                    if (this.pb_selectList.length != 1) {
                        this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 3)
                        return;
                    } else {
                        this.QueryUpdatas = {};
                        let paramsData = [];
                        let dataValues = this.pb_selectList[0];
                        let params = {
                            gmcUid: val.pattern.gmcUid,
                            dataUid: dataValues.uid,
                            language: this.lang
                        };
                        this.eddvisible = true;
                        ajax.post(api.POPUP, params).then(res => {
                            this.QueryUpdatas = res;
                            this.QueryUpdatas.behrUid = val.btnUid;
                            this.QueryUpdatas.lookupCode = val.code;
                            this.QueryUpdatas.lookupGmcuid = val.pattern.gmcUid;
                            this.apiType = "edit";
                        });
                    }
                }
                //        import
                if (val.code == "BTN_IMPORT") {
                    if(val.pattern != null &&  val.pattern.custPage == "importStoreArrivalExcel"){
                        this.$refs.storeArrivalExcelRef.show();
                        return
                    }
                    if(val.pattern != null &&  val.pattern.custPage == "importKateSpadeExcel"){
                        this.$refs.kateSpadeExcel.show();
                        return
                    }
                    if(val.pattern != null && val.pattern.custPage == "importScanningFile") {
                        if (this.pb_selectList.length != 1) {
                            this.$customMessage.warning(this.$t('publicLang.pleaseOneOnly'), 3);
                            return;
                        }
                        let uid = '';
                        let deleteData = this.pb_selectList;
                        for (let index in deleteData) {
                            if (deleteData[index].uid != "") {
                                uid = deleteData[index].uid;
                            }
                        }                        
                        this.$refs.importScanningFile.show(uid);
                        return;
                    }  
                    let params = {
                        btnUid: val.btnUid,
                        userUid: this.$route.query.userUid,
                        language: this.lang,
                        fieldMapUid: val.mapUid,
                        importTitle: val.name,
                        isMove: val.pattern.custPage
                    };
                    if(val.type == "POPUP" && val.viewType == "SINGLE"){
                        let specialModule = []
                        if(this.data.tableList.info == "GR_HEADER"){
                            if(this.pb_selectList.length < 1){
                                this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 3)
                                return
                            }
                            specialModule = this.pb_selectList
                        }else{
                            if (this.pb_selectList.length != 1){
                                this.$customMessage.warning(this.$t('publicLang.pleaseOneOnly'), 3)
                                return;
                            }
                        }

                        this.QueryUpdatas = {};
                        let paramsData = [];
                        let dataValues = this.pb_selectList[0];
                        params = {
                            gmcUid: val.pattern.gmcUid,
                            importForView: {
                                dataUid: dataValues.uid,
                                gmcUid: this.tableGmcuid,
                                mapUid: val.mapUid
                            },
                            language: this.lang
                        }
                        this.isBtnajax = true
                        ajax.post(api.POPUP, params).then(res => {
                            this.isBtnajax = false
                            this.QueryUpdatas = res;
                            this.QueryUpdatas.uid = dataValues.uid
                            this.QueryUpdatas.specialModule = specialModule
                            this.QueryUpdatas.behrUid = val.btnUid;
                            this.QueryUpdatas.fieldMapUid = val.mapUid;
                            this.QueryUpdatas.toGmcuid = val.pattern.gmcUid;
                            this.QueryUpdatas.lookupCode = val.code;
                            this.QueryUpdatas.lookupGmcuid = val.pattern.gmcUid;
                            this.QueryUpdatas.type = 'To'
                            if(val.pattern.action == "scanin"){
                                this.QueryUpdatas.zdSave = true
                            }
                            this.apiType = "edit";
                            this.eddvisible = true;
                        });
                        return
                    }

                    if (val.type == "POPUP" && val.viewType == "LIST") {
                        params.importType = "DB";
                        params.gmcUid = val.pattern.gmcUid;
                        params.partTableUid = this.tableGmcuid;
                    } else if (val.type == "File" && val.viewType == "EXCEL") {
                        params.importType = "excel";
                        params.gmcUid = val.pattern.gmcUid;
                    } else {
                        this.$customMessage.warning(this.$t('publicLang.SystemAdministrator'), 3)
                        return;
                    }
                    this.importparams = params;
                    this.importVisible = true;
                }
                //                pdf
                if (val.code == "BTN_PRINT") {
                    console.log("print---start");
                    if(val.externalApi == '/so/generateLabel' || val.externalApi == '/so/generateMainfest' || val.externalApi == '/so/cancelLabel') {
                        // 准备请求所需的params
                        let paramsData = [];
                        if (val.pattern.params.length > 0) {
                            if(this.pb_selectList.length < 1) {
                                this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 3);
                                return;
                            }
                        }
                        let SaveData = this.pb_selectList;
                        let patternParams = val.pattern.params;
                        for (let instance of SaveData) {
                            if (instance.uid != "") {
                                let paramsObj = {};
                                paramsObj.key = "uid";
                                paramsObj.value = instance.uid;
                                paramsData.push(paramsObj);
                            }
                        }
                        let params = {
                            behrUid: val.btnUid,
                            userUid: this.$route.query.userUid,
                            functionUid: this.$route.query.funcUid,
                            gmcUid: val.pattern.gmcUid,
                            params: paramsData,
                            language: this.lang
                        };
                        // 请求
                        let ajaxurl = ajax.ajaxUrl();
                        axios.post( ajaxurl + val.externalApi, params).then(res => {
                            if (res.data.code == 200) {
                                if (val.externalApi == '/so/generateLabel') {
                                    let urlStr = res.data.data;
                                    this.shipmentUrl = urlStr.split(",");
                                    // this.shipmentUrl = res.msg;
                                    if (this.shipmentUrl == null || this.shipmentUrl.length == 0) {
                                        this.$message.success("No Data", 3);
                                    }
                                    for (let i = 0; i <this.shipmentUrl.length ; i++) {
                                        window.open(this.shipmentUrl[i]);
                                    }
                                } else {
                                    this.initRenderFn();
                                    this.$message.success(res.data.msg,3);
                                }
                            } else {
                                // this.$customMessage.warning(res.data.msg, 3);
                                this.$warning({
                                    title: <div style="color:red; font-size: 25px;">Error</div>,
                                    content: res.data.msg,
                                    width: '520px',
                                });
                            }
                        });
                    } else {
                        if(val.viewType == "LIST"){
                            if (this.pb_selectList.length <1) {
                                this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 3)
                                return;
                            }
                        }else{
                            if (this.pb_selectList.length != 1) {
                                this.$customMessage.warning(this.$t('publicLang.pleaseOneOnly'), 3)
                                return;
                            }
                        }
                        let ajaxurl = ajax.ajaxUrl();
                        let tt = [];
                        for (let ii in this.pb_selectList) {
                            tt.push(this.pb_selectList[ii].uid);
                        }
                        if(val.name=="Tods_Picking_List_B2B" || val.name=="Tods_Picking_List_B2C"){
                            axios.post(ajaxurl +api.PRINTTODSB2BPICKINGLIST, tt ).then(res => {
                                let that = this
                                if (res.data.code == 200) {
                                    that.$message.success(res.data.msg, 3);
                                    this.printPreview(tt,val);
                                }else{
                                    that.$customMessage.warning(res.data.msg, 3);
                                    return ;
                                }
                            });
                        }else{
                            this.printPreview(tt,val);
                        }

                    }
                }
                //        export
                if (val.code == "BTN_EXPORT") {
                    if (val.patternType == "EXT") {
                        let paramsData = [];
                        if (val.pattern.params.length > 0) {
                            if (this.pb_selectList.length < 1) {
                                this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 3)
                                return;
                            }
                            let SaveData = this.pb_selectList;
                            let patterParams = val.pattern.params;
                            for (let index in SaveData) {
                                if (SaveData[index].uid != "") {
                                    let paramsObj = {};
                                    paramsObj.key = "uid";
                                    paramsObj.value = SaveData[index].uid;
                                    paramsData.push(paramsObj);
                                }
                            }
                        }
                        let params = {
                            behrUid: val.btnUid,
                            userUid: this.$route.query.userUid,
                            functionUid: this.$route.query.funcUid,
                            gmcUid: val.pattern.gmcUid,
                            params: paramsData,
                            language: this.lang
                        };
                        let ajaxurl = ajax.ajaxUrl();
                        if(val.externalApi == api.EXPORTGARMANIDELIVERYNOTE || val.api == api.EXPORTGARMANIDELIVERYNOTE ){
                            if(val.externalApi != null ){
                                ajax.exportExcel(ajaxurl + val.externalApi,params).then(data => {
                                    if (!data) {
                                        return;
                                    }
                                    let type = data.data.type;
                                    let that = this;
                                    const relType = ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']
                                    if( type.includes('application/json')){
                                        let reader = new FileReader()
                                        reader.onload = function (event) {
                                            let content = reader.result
                                            let msg = JSON.parse(content).msg
                                            that.$customMessage.warning(msg);
                                        }
                                        reader.readAsText(data.data)
                                        return
                                    }else {
                                        var blob = new Blob([data.data], {
                                            type:
                                                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
                                        });
                                        var url = window.URL.createObjectURL(blob);
                                        var aLink = document.createElement("a");
                                        aLink.style.display = "none";
                                        aLink.href = url;
                                        aLink.setAttribute("download", "excel.xlsx");
                                        document.body.appendChild(aLink);
                                        aLink.click();
                                        document.body.removeChild(aLink); //下载完成移除元素
                                        window.URL.revokeObjectURL(url); //释放掉blob对象
                                    }
                                }).catch(function(error) {
                                    alert(error);
                                })
                                return
                            }else{
                                let ajaxurl = ajax.ajaxUrl();
                                this.isBtnajax = true
                                let that = this
                                axios.get(ajaxurl + val.externalApi, {
                                    params: {
                                        btnUid: val.btnUid,
                                        language: this.lang
                                    },
                                    headers: {
                                        Authorization: cookie.getBearerToken()
                                    },
                                    responseType: "blob" //二进制流
                                })
                                    .then(function(data) {
                                        that.isBtnajax = false
                                        if (!data) {
                                            return;
                                        }
                                        var blob = new Blob([data.data], {
                                            type:
                                                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
                                        });
                                        var url = window.URL.createObjectURL(blob);
                                        var aLink = document.createElement("a");
                                        aLink.style.display = "none";
                                        aLink.href = url;
                                        aLink.setAttribute("download", "excel.xlsx");
                                        document.body.appendChild(aLink);
                                        aLink.click();
                                        document.body.removeChild(aLink); //下载完成移除元素
                                        window.URL.revokeObjectURL(url); //释放掉blob对象
                                    })
                                    .catch(function(error) {
                                        alert(error);
                                    });
                            }
                        }else if(val.externalApi == api.EXPORTPACKAGEDATA){
                            axios.post(ajaxurl + val.externalApi,params,{ responseType: 'blob'}).then(data => {
                                if (!data) {
                                    return;
                                }
                                let type = data.data.type;
                                let that = this;
                                if( type.includes('application/json')){
                                    let reader = new FileReader()
                                    reader.onload = function (event) {
                                        let content = reader.result
                                        let msg = JSON.parse(content).msg
                                        that.$customMessage.warning(msg);
                                    }
                                    reader.readAsText(data.data)
                                    return
                                }else {
                                    var blob = new Blob([data.data], {
                                        type:
                                            "APPLICATION/OCTET-STREAM"
                                    });
                                    var url = window.URL.createObjectURL(blob);
                                    var aLink = document.createElement("a");
                                    aLink.style.display = "none";
                                    aLink.href = url;
                                    aLink.setAttribute("download", val.externalApi == api.EXPORTPACKAGEDATA ? "ExportDelivery.rar" : "ReleaseReports.rar");
                                    document.body.appendChild(aLink);
                                    aLink.click();
                                    document.body.removeChild(aLink); //下载完成移除元素
                                    window.URL.revokeObjectURL(url); //释放掉blob对象
                                    
                                    // 再次请求，校验得出导出的信息，避免出现勾选的So Order掺杂着一部分不允许导出的
                                    //var checkStatusUrl = ajaxurl + api.CHECKEXPORTSOORDERSTATUS;
                                    //axios.post( checkStatusUrl, params ).then(data => {
                                    //    if(data.data.code == 200){
                                    //        this.$message.success(data.data.msg);
                                    //    } else {
                                    //        this.$customMessage.warning(data.data.msg);
                                    //    }
                                    //})
                                }
                            })
                        } else if (val.externalApi == api.EXPORTSHIPMENTCONFIRMATION) {

                            axios.post(ajaxurl + val.externalApi, params,{ responseType: 'blob'}).then(data => {
                                if (!data) {
                                    return;
                                }
                                let type = data.data.type;
                                let that = this;

                                if (type.includes('application/json')) {
                                    let reader = new FileReader()
                                    reader.onload = function (event) {
                                        let content = reader.result
                                        let msg = JSON.parse(content).msg
                                        that.$customMessage.warning(msg);
                                    }
                                    reader.readAsText(data.data)
                                    return
                                } else {
                                    var blob = new Blob([data.data], {
                                        type: "application/zip"
                                    });
                                    var url = window.URL.createObjectURL(blob);
                                    var aLink = document.createElement("a");
                                    aLink.style.display = "none";
                                    aLink.href = url;
                                    aLink.setAttribute("download", "ShipmentConfirmation.zip");
                                    document.body.appendChild(aLink);
                                    aLink.click();
                                    document.body.removeChild(aLink); //下载完成移除元素
                                    window.URL.revokeObjectURL(url); //释放掉blob对象
                                }

                            })

                        } else if(val.externalApi == api.RELEASEREPORTBYEXCEL){
                            // 先校验Order的状态，在判断是否导出
                            axios.post(ajaxurl + api.VERIFYORDERANDGROUPBYSHIPMENTNO, params).then ( data => {
                                if(data.data.code === 200) {
                                    const shipmentMap = data.data.data;
                                    let failExportOrder = '';
                                    let errorStr = data.data.data.exportOrderStatusError;
                                    let errorOrderList = data.data.data.exportOrderStatusErrorList;
                                    if(errorStr != null || errorOrderList != null) {
                                        for(let i = 0 ; i < errorOrderList.length; i++) {
                                            failExportOrder += errorOrderList[i] + ',';
                                        }
                                        failExportOrder = failExportOrder.substring(0, failExportOrder.length - 1);
                                        failExportOrder += ' ' + errorStr + '\n';
                                    }
                                    if (shipmentMap.shipmentNoMap != null && Object.keys(shipmentMap['shipmentNoMap']).length != 0) {
                                        // 多次请求来导出不同的excel
                                        const res = this.batchExportReportByExcels(params, shipmentMap,  val, ajaxurl);
                                        res.then(async result => {
                                            for (let i = 0; i < result.length; i++) {
                                                const data = result[i];
                                                if(!data) {
                                                    return;
                                                }
                                                let type = data.data.type;
                                                let that = this;
                                                const relType = ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
                                                if (type.includes('application/json')) {
                                                    let reader = new FileReader()
                                                    const readerPromise = new Promise(resolve => {
                                                        reader.onload = function(event) {
                                                            let content = reader.result;
                                                            let msg = JSON.parse(content).msg;
                                                            resolve(msg);
                                                        };
                                                    });
                                                    reader.readAsText(data.data);
                                                    const msg = await readerPromise;
                                                    // 拼接错误信息
                                                    failExportOrder += (msg + '\n');
                                                } else {
                                                    var blob = new Blob([data.data], {
                                                        type:
                                                            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
                                                    });
                                                    var url = window.URL.createObjectURL(blob);
                                                    var aLink = document.createElement("a");
                                                    aLink.style.display = "none";
                                                    aLink.href = url;
                                                    aLink.setAttribute("download", "excel.xlsx");
                                                    document.body.appendChild(aLink);
                                                    aLink.click();
                                                    document.body.removeChild(aLink); //下载完成移除元素
                                                    window.URL.revokeObjectURL(url); //释放掉blob对象   
                                                }
                                            }
                                            if (failExportOrder != '') {
                                                this.$customMessage.warning(failExportOrder);
                                            } else {
                                                this.$message.success("Success!");
                                            }
                                        });
                                    } else {
                                        this.$customMessage.warning(failExportOrder);
                                    }
                                } else {
                                    this.$customMessage.warning(data.data.msg)
                                }
                            });
                        }else{
                            let ajaxurl = ajax.ajaxUrl();
                            this.isBtnajax = true
                            let that = this
                            axios.get(ajaxurl + val.externalApi, {
                                params: {
                                    btnUid: val.btnUid,
                                    language: this.lang
                                },
                                headers: {
                                    Authorization: cookie.getBearerToken()
                                },
                                responseType: "blob" //二进制流
                            })
                                .then(function(data) {
                                    that.isBtnajax = false
                                    if (!data) {
                                        return;
                                    }
                                    var blob = new Blob([data.data], {
                                        type:
                                            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
                                    });
                                    var url = window.URL.createObjectURL(blob);
                                    var aLink = document.createElement("a");
                                    aLink.style.display = "none";
                                    aLink.href = url;
                                    aLink.setAttribute("download", "excel.xlsx");
                                    document.body.appendChild(aLink);
                                    aLink.click();
                                    document.body.removeChild(aLink); //下载完成移除元素
                                    window.URL.revokeObjectURL(url); //释放掉blob对象
                                })
                                .catch(function(error) {
                                    alert(error);
                                });

                        }
                    }
                  if(val.viewType == "EXCEL"){
                        let params = {
                            gmcUid: this.tableGmcuid,
                            language: this.lang,
                            export: 'excel',
                        }
                        let arr = this.initRenderFnSearchParamsArr.andvanSearchArr // adv search
                        let tileArr = this.initRenderFnSearchParamsArr.titleSearchArr // title Search
                        if(tileArr.length > 0 ){
                            params.columnSearch = tileArr
                        }else{
                            if(!(arr instanceof Array)){
                                if(JSON.stringify(arr) !="{}"){
                                     params.userSqlDto = arr
                                }else if(this.parTableTemplateName != undefined && this.parTableTemplateName != null){                                
                                   params.userSqlDto = {};
                                   params.userSqlDto.gmcUid = this.tableGmcuid
                                   params.userSqlDto.template = this.parTableTemplateName                  
                               }
                            }
                        }


                      let topMenu = JSON.parse(sessionStorage.getItem("menu"))
                      let topMenuActive = sessionStorage.getItem("menuActive")
                      for(let i in topMenu){
                          if(topMenu[i].key == topMenuActive){
                              if(topMenu[i].importUids){
                                  params.importUids = topMenu[i].importUids
                              }
                              if(topMenu[i].skuInfo){
                                  params.skuInfo = topMenu[i].skuInfo
                              }
                          }
                      }




                      let ajaxurl = ajax.ajaxUrl();
                        this.isBtnajax = true
                        let that = this
                        ajax.exportExcel(ajaxurl+api.SKUS,params).then(data=>{
                            that.isBtnajax = false
                            if (!data) {
                                return;
                            }
                            var blob = new Blob([data.data], {
                                type:
                                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
                            });
                            var url = window.URL.createObjectURL(blob);
                            var aLink = document.createElement("a");
                            aLink.style.display = "none";
                            aLink.href = url;
                            aLink.setAttribute("download", "excel.xlsx");
                            document.body.appendChild(aLink);
                            aLink.click();
                            document.body.removeChild(aLink); //下载完成移除元素
                            window.URL.revokeObjectURL(url); //释放掉blob对象
                        })
                    }
                }
//      save
                if (val.code == "BTN_SAVE") {
				
					if(val.pattern.custPage == 'SkuSearch'){
								this.$refs.skuSearch.show()
									return
					}
                    if(val.pattern != null && val.pattern.custPage == "groupWave") {

                        let params = {
                            gmcUid: this.tableGmcuid,
                            language: this.lang,
                            export: 'sql',
                        }
                        let arr = this.initRenderFnSearchParamsArr.andvanSearchArr // adv search
                        let tileArr = this.initRenderFnSearchParamsArr.titleSearchArr // title Search
                        if(tileArr.length > 0 ){
                            params.columnSearch = tileArr
                        }else{
                            if(!(arr instanceof Array)){
                                if(JSON.stringify(arr) !="{}"){
                                    params.userSqlDto = arr
                                }else if(this.parTableTemplateName != undefined && this.parTableTemplateName != null){
                                    params.userSqlDto = {};
                                    params.userSqlDto.gmcUid = this.tableGmcuid
                                    params.userSqlDto.template = this.parTableTemplateName
                                }
                            }
                        }

                        this.$refs.groupWave.show(params);
                        return;
                    }


                    if(val.pattern != null && val.pattern.custPage == "groupWave") {
                        this.$refs.groupWave.show();
                        return;
                    }

                if(val.pattern.custPage == 'addSoToWave'){
                        if (this.pb_selectList.length < 1) {
                            this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 3)
                            return;
                        }

                        let columns = this.data.tableList.columns
                        let statusGmdUid = 0;
                        let relIdGmdUid = 0;
                        let waveIdGmdUid = 0;
                        this.addSoToWaveRelIdList = [] 

                        for(let i in columns){
                           let  column =  columns[i];
                           if(column.flag == undefined && column.flag == null){
                            continue;
                           }else if( column.flag.toLowerCase() == 'status') {
                                statusGmdUid = column.uid
                           }else if( column.flag.toLowerCase() == 'rel_id') {
                                relIdGmdUid = column.uid
                           }else if( column.flag.toLowerCase() == 'wave_id'){
                                waveIdGmdUid  = column.uid
                           }
                        }

                        if(statusGmdUid == 0 ){
                            this.$customMessage.warning('Configuration error, STATUS cannot be recognized')
                            return;
                        }
                        if(relIdGmdUid == 0){
                             this.$customMessage.warning('Configuration error, REL ID cannot be recognized')
                            return;
                        }
                      if(waveIdGmdUid == 0){
                             this.$customMessage.warning('Configuration error, WAVE ID cannot be recognized')
                            return;
                        }
                        let statusError = '';
                         let waveError = '';
                        //  console.info(this.pb_selectList)
                         
                    //     // 校验选择数据的准确性
                        for(let i in this.pb_selectList){
                            let row =  this.pb_selectList[i];
                               let orderNo = row[relIdGmdUid].value;
                            
                            if(row[statusGmdUid].code != '00' ){
                                if( statusError.length > 0){
                                    statusError+=','
                                }
                                statusError += orderNo;
                            }
                         
                            if(row[waveIdGmdUid].code != null && row[waveIdGmdUid].code.length > 0){
                                if( waveError.length > 0){
                                    waveError+=','
                                }
                                waveError += orderNo;
                            }
                            this.addSoToWaveRelIdList.push(orderNo)
                        }

                        let errMsg = '';
                        if(statusError.length > 0){
                            errMsg += this.$t('publicLang.statusError',{"0":statusError})
                            errMsg += "\n"                                                                                                       
                        }

                      if(waveError.length > 0){
                            errMsg += this.$t('publicLang.waveIdIsNotEmpty',{"0":waveError})
                        }
                    
                        if(errMsg.length > 0){     
                                         
                          this.$customMessage.warning(errMsg, 3)
                            return
                        }else{
                            this.addSoToWaveVisible = true;
                            return
                        }                   
                    }else  if(val.pattern.custPage == 'assignPickLocToUser'){
                    if (this.pb_selectList.length != 1) {
                        this.$customMessage.warning(this.$t('publicLang.pleaseOneOnly'), 3)
                        this.isBtnajax = false
                        return;
                    }
                    let columns = this.data.tableList.columns
                    let statusGmdUid = 0;
                    let relIdGmdUid = 0;

                    for(let i in columns){
                        let  column =  columns[i];
                        if(column.flag == undefined && column.flag == null){
                            continue;
                        }else if( column.flag.toLowerCase() == 'status') {
                            statusGmdUid = column.uid
                        }else if( column.flag.toLowerCase() == 'rel_id') {
                            relIdGmdUid = column.uid
                        }
                    }
                    if(statusGmdUid == 0 ){
                        this.$customMessage.warning('Configuration error, STATUS cannot be recognized')
                        return;
                    }

                    let row =  this.pb_selectList[0];
                    let orderNo = row[relIdGmdUid].value;
                    let status = row[statusGmdUid].code;
                    console.log("status:"+status)
                    if(status != '40' &&  status != '30'){
                        let errMsg = this.$t('publicLang.statusError',{"0":orderNo})
                        this.$customMessage.warning(errMsg, 3)
                        return
                    }else{
                        this.$refs.assignPickLocToUser.show(orderNo);
                    }
                    //this.$refs.assignPickLocToUser.show(orderNo);

                } else if (val.pattern.custPage == 'createDhlShipmentId') {

                    if (this.pb_selectList.length < 1) {
                        this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 3)
                        this.isBtnajax = false
                        return;
                    }

                    let orderUids = [];

                    // collect batch selected data uids
                    let batchdata = this.pb_selectList;
                    let batchDataArr = [];
                    for (let index in batchdata) {
                        if (batchdata[index].uid != "") {
                            orderUids.push(batchdata[index].uid);
                        }
                    }

                    this.$refs.createDhlShipmentId.show(orderUids);

                } else if (val.pattern.custPage == 'addOrderToShipmentId') {

                    if (this.pb_selectList.length < 1) {
                        this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 3)
                        this.isBtnajax = false
                        return;
                    }

                    let orderUids = [];

                    // collect batch selected data uids
                    let batchdata = this.pb_selectList;
                    let batchDataArr = [];
                    for (let index in batchdata) {
                        if (batchdata[index].uid != "") {
                            orderUids.push(batchdata[index].uid);
                        }
                    }

                    this.$refs.addOrderToShipmentId.show(orderUids);
                }


                    if (val.type == "BUTTON" && val.patternType == "EXT") {
                        let paramsData = [];
                        if (val.pattern.params.length > 0) {
                            if (this.pb_selectList.length < 1) {
                                this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 3)
                                return;
                            }
                            let SaveData = this.pb_selectList;
                            let patterParams = val.pattern.params;
                            for (let index in SaveData) {
                                if (SaveData[index].uid != "") {
                                    let paramsObj = {};
                                    paramsObj.key = "uid";
                                    paramsObj.value = SaveData[index].uid;
                                    paramsData.push(paramsObj);
                                }
                            }
                        }
                        let params = {
                            behrUid: val.btnUid,
                            userUid: this.$route.query.userUid,
                            functionUid: this.$route.query.funcUid,
                            gmcUid: val.pattern.gmcUid,
                            params: paramsData,
                            language: this.lang
                        };
                        let that =this
                        if (val.externalApi=="/cfs/so/printLabelUrl" ){
                            ajax.post(val.externalApi, params).then(res => {
                                if (res.code == 200) {
                                    if(val.externalApi=="/cfs/so/printLabelUrl" ){
                                        console.info(res.data)
                                        let urlStr =  res.data;
                                        this.soUrl= urlStr.split(",")
                                        // this.shipmentUrl=res.msg;
                                        if(this.soUrl==null || this.soUrl.length==0){
                                            this.$message.success("No Data", 3);
                                        }
                                        for (let i = 0; i <this.soUrl.length ; i++) {
                                            window.open(this.soUrl[i]);
                                        }
                                    }else {
                                        that.initRenderFn();
                                        that.$message.success(res.msg, 3);
                                    }
                                } else {
                                    that.$customMessage.warning(res.msg, 3);
                                }
                            });
                        } else if (val.externalApi=="outbound/extender/getExpressNumber") {
                            ajax.post(val.externalApi, params).then(res => {
                                if (res.code == 200) {

                                        console.info(res.data)
                                        let urlStr =  res.data;
                                        this.soUrl= urlStr.split(",")
                                        // this.shipmentUrl=res.msg;
                                        if(this.soUrl==null || this.soUrl.length==0){
                                            this.$message.success("No Data", 3);
                                        }
                                        for (let i = 0; i <this.soUrl.length ; i++) {
                                            window.open(this.soUrl[i]);
                                        }

                                } else {
                                    that.$customMessage.warning(res.msg, 3);
                                }
                            });
                        } else if (val.externalApi=="outbound/extender/sfReturnPreallocate") {
                            ajax.post(val.externalApi, params).then(res => {
                                if (res.code == 200) {
                                    // show data
                                    console.info(res.data)
                                    // URLs
                                    let urlStr =  res.data;
                                    this.soUrl= urlStr.split(",")
                                    if (this.soUrl != null && this.soUrl.length > 0) {
                                        // show URLs
                                        for (let i = 0; i <this.soUrl.length ; i++) {
                                            window.open(this.soUrl[i]);
                                        }
                                    } else {
                                        // show message
                                        this.$message.success("No Data", 3);
                                    }
                                } else {
                                    that.$customMessage.warning(res.msg, 3);
                                }
                            });
                        } else if (val.externalApi=="outbound/extender/farfetchConfirmStock") {
                            ajax.post(val.externalApi, params).then(res => {
                                if (res.code == 200) {
                                    // show data
                                    console.info(res.data)
                                    // URLs
                                    let urlStr =  res.data;
                                    this.soUrl= urlStr.split(",")
                                    if (this.soUrl != null && this.soUrl.length > 0) {
                                        // show URLs
                                        for (let i = 0; i <this.soUrl.length ; i++) {
                                            window.open(this.soUrl[i]);
                                        }
                                    } else {
                                        // show message
                                        this.$message.success("No Data", 3);
                                    }
                                } else {
                                    that.$customMessage.warning(res.msg, 3);
                                }
                            });
                        } else if (val.externalApi=="/outbound/extender/printShipmentDoc") {
                            ajax.post(val.externalApi, params).then(res => {
                                if (res.code == 200) {
                                    // show data
                                    console.log(res.data)
                                    // URLs
                                    let urlStr =  res.data.urls;
                                    if (urlStr != null && urlStr != undefined && urlStr.length > 0) {
                                        let urls = urlStr.split(",");
                                        for (let i = 0; i < urls.length; i++) {
                                            window.open(urls[i]);
                                        }
                                    }
                                    // error msgs
                                    let msgs = res.data.msgs;
                                    if(msgs != null && msgs != undefined && msgs.length > 0) {
                                        that.$customMessage.warning(msgs, 5);
                                    }
                                } else {
                                    that.$customMessage.warning(res.msg, 3);
                                }
                            });
                        } else if (val.externalApi=="/outbound/extender/printDhlLabelBBX") {
                            ajax.post(val.externalApi, params).then(res => {
                                if (res.code == 200) {
                                    // URLs
                                    let urlStr =  res.data.urls;
                                    if (urlStr != null && urlStr != undefined && urlStr.length > 0) {
                                        let urls = urlStr.split(",");
                                        this.previewHttpFiles(urls);
                                    }
                                    // error msgs
                                    let msgs = res.data.msgs;
                                    if(msgs != null && msgs != undefined && msgs.length > 0) {
                                        that.$customMessage.warning(msgs, 5);
                                    }
                                } else {
                                    that.$customMessage.warning(res.msg, 3);
                                }
                            });
                        } else if (val.externalApi=="/outbound/extender/printDhlLabelMAWB") {
                            ajax.post(val.externalApi, params).then(res => {
                                if (res.code == 200) {
                                    // URLs
                                    let urlStr =  res.data.urls;
                                    if (urlStr != null && urlStr != undefined && urlStr.length > 0) {
                                        let urls = urlStr.split(",");
                                        this.previewHttpFiles(urls);
                                    }
                                    // error msgs
                                    let msgs = res.data.msgs;
                                    if(msgs != null && msgs != undefined && msgs.length > 0) {
                                        that.$customMessage.warning(msgs, 5);
                                    }
                                } else {
                                    that.$customMessage.warning(res.msg, 3);
                                }
                            });
                        } else if (val.externalApi=="/outbound/extender/printDhlCargoReceiptSo") {
                            ajax.post(val.externalApi, params).then(res => {
                                if (res.code == 200) {
                                    // URLs
                                    let urlStr =  res.data.urls;
                                    if (urlStr != null && urlStr != undefined && urlStr.length > 0) {
                                        let urls = urlStr.split(",");
                                        this.previewHttpFiles(urls);
                                    }
                                    // error msgs
                                    let msgs = res.data.msgs;
                                    if(msgs != null && msgs != undefined && msgs.length > 0) {
                                        that.$customMessage.warning(msgs, 5);
                                    }
                                } else {
                                    that.$customMessage.warning(res.msg, 3);
                                }
                            });
                        } else if (val.externalApi=="/outbound/extender/removeOrderFromShipmentId") {
                            ajax.post(val.externalApi, params).then(res => {
                                if (res.code == 200) {
                                    that.$message.success(res.msg, 3);
                                } else {
                                    that.$customMessage.warning(res.msg, 3);
                                }
                            });
                        } else if(val.externalApi=="/outbound/skynetCreateShipment"){
                            ajax.post(val.externalApi, params).then(res => {
                                if (res.code == 200) {
                                    let returnData =  res.data;
                                    if(null!=returnData){
                                        that.$alert(returnData,
                                            {	showClose:false,
												dangerouslyUseHTMLString: true,
                                                confirmButtonText:this.$t('publicLang.Confirm')
                                            }
                                        );
                                        return;
                                    }else {
                                        that.$alert(res.msg,
                                            {	showClose:false,
												dangerouslyUseHTMLString: true,
                                                confirmButtonText:this.$t('publicLang.Confirm')
                                            }
                                        );
                                        return;
                                    }
                                } else {
                                    that.$alert(res.msg,
                                        {	showClose:false,
											dangerouslyUseHTMLString: true,
                                            confirmButtonText:this.$t('publicLang.Confirm')
                                        }
                                    );
                                    return;
                                }
                            });
                        }else if(val.externalApi=="/outbound/skyCancelShipment"){
                            ajax.post(val.externalApi, params).then(res => {
                                if (res.code == 200) {
                                    let returnData =  res.data;
                                    if(null!=returnData){
                                        that.$alert(returnData,
                                            {showClose:false,
                                                dangerouslyUseHTMLString:true,
                                                confirmButtonText:this.$t('publicLang.Confirm')
                                            }
                                        );
                                        return;
                                    }else {
                                        that.$alert(res.msg,
                                            {showClose:false,
                                                dangerouslyUseHTMLString:true,
                                                confirmButtonText:this.$t('publicLang.Confirm')
                                            }
                                        );
                                        return;
                                    }
                                } else {
                                    that.$alert(res.msg,
                                        {showClose:false,
                                            dangerouslyUseHTMLString:true,
                                            confirmButtonText:this.$t('publicLang.Confirm')
                                        }
                                    );
                                    return;
                                }
                            });
                        }else if (val.externalApi=="outbound/extender/releaseToAmr") {
                            ajax.post(val.externalApi, params).then(res => {
                                if (res.code == 200) {
                                    that.$message.success(res.msg, 3);
                                } else {
                                    that.$customMessage.warning(res.msg, 3);
                                }
                            });
                        }else if (val.externalApi=="outbound/extender/cancelToAmr") {
                            ajax.post(val.externalApi, params).then(res => {
                                if (res.code == 200) {
                                    that.$message.success(res.msg, 3);
                                } else {
                                    that.$customMessage.warning(res.msg, 3);
                                }
                            });
                        }
                        else {
                            let DEL_ALLOCATION_MV = this.systemParam.DEL_ALLOCATION_MV == undefined ? 'N' : this.systemParam.DEL_ALLOCATION_MV;
                            if("/soHeader/extender/de-all" == val.externalApi && "Y" == DEL_ALLOCATION_MV){
                                this.$customConfirm({
                                    title: this.$t('scanPack.cancelCheckCompleteMoveMsg'),
                                    okText: this.$t('generic.Yes'),
                                    okType: 'confirm',
                                    cancelText: this.$t('generic.No'),
                                    onOk() {
                                        ajax.post(val.externalApi, params).then(res => {
                                            if (res.code == 200) {
                                                that.initRenderFn();
                                                that.$message.success(res.msg, 3);
                                            } else {
                                                that.$customMessage.warning(res.msg, 3);
                                            }
                                        });
                                    },
                                    onCancel() {
                                        if (params.params.length != 1) {
                                            that.$customMessage.warning(that.$t('publicLang.pleaseOneOnly'), 3)
                                            return;
                                        }
                                        params.type = 'Y'
                                        ajax.post(val.externalApi, params).then(res => {
                                            if (res.code == 200) {
                                                that.initRenderFn();
                                                that.$refs.scanPackMove.show2(res.data,true)
                                            } else {
                                                that.$customMessage.warning(res.msg, 3);
                                            }
                                        });
                                    }
                                })
                            }else {
                                this.$customConfirm({
                                    title: this.$t('processActionMsg'),//'Do you want to process the action?',
                                    okText: this.$t('publicLang.Confirm'),//'Confirm',
                                    okType: 'confirm',
                                    cancelText: this.$t('publicLang.Cancel'),//'Cancel',
                                    onOk() {
                                        ajax.post(val.externalApi, params).then(res => {
                                            if (res.code == 200) {
                                                if("/so/creatWave" == val.externalApi){
                                                    that.$message.success(res.msg, 3);
                                                    that.routerWavePage(res.data)
                                                } else if (val.externalApi=="/outbound/extender/cancelShip") {
                                                    let uidList = params.params
                                                        .filter(param => param.key === "uid")  // 筛选出 key 为 "uid" 的参数 Filter out parameters with the key "uid".
                                                        .map(param => param.value);           // 提取 value 值 Extract the value(s)
                                                    if(uidList != undefined && uidList != null && uidList.length > 0) {
                                                        let topMenu = JSON.parse(sessionStorage.getItem("menu"))
                                                        let topMenuActive = sessionStorage.getItem("menuActive")
                                                        for(let i in topMenu){
                                                            if(topMenu[i].key == topMenuActive){
                                                                let idStr =uidList.join(',');
                                                                let array =  idStr.split(",")
                                                                if (array.length <= 100) {
                                                                    topMenu[i].importUids = idStr;
                                                                }
                                                            }
                                                        }
                                                        sessionStorage.setItem("menu", JSON.stringify(topMenu));
                                                    }
                                                    that.$message.success(res.msg, 3);
                                                    that.init();
                                                } else {
                                                    that.initRenderFn();
                                                    that.$message.success(res.msg, 3);
                                                }
                                            } else {
                                                that.$customMessage.warning(res.msg, 3);
                                            }
                                        });
                                    },
                                })
                            }
                        }
                    }
                    if (val.type == "POPUP" && val.viewType == "SINGLE") {
                        if (this.pb_selectList.length != 1) {
                            this.$customMessage.warning(this.$t('publicLang.pleaseOneOnly'), 3)
                            return;
                        }
                        this.QueryUpdatas = {};
                        let paramsData = [];
                        let dataValues = this.pb_selectList[0];
                        let params = {
                            gmcUid: val.pattern.gmcUid,
                            dataUid: dataValues.uid,
                            language: this.lang,
                            isChecked: false
                        };
                        this.$nextTick(() => {
                            this.$refs.popupSingleRef.openPopup();
                        });
                        ajax.post(api.POPUP, params).then(res => {
                            this.QueryUpdatas = res;
                            this.QueryUpdatas.behrUid = val.btnUid;
                        });
                    }
                    if (val.type == "POPUP" && val.viewType == "LIST") {
                        let params = {
                            btnUid: val.btnUid,
                            userUid: this.$route.query.userUid,
                            language: this.lang,
                            fieldMapUid: val.mapUid,
                            importTitle: val.name
                        };
                        params.importType = "DB";
                        params.gmcUid = val.pattern.gmcUid;
                        this.importparams = params;
                        this.importVisible = true;
                    }
                    //            弹指定弹窗
                    if(val.type == "POPUP" && val.pattern.custPage == "lookUp"){
                        if (this.pb_selectList.length != 1) {
                            this.$customMessage.warning(this.$t('publicLang.pleaseOneOnly'), 3)
                            return;
                        }
                        let feildArr = []
                        let dataValues = this.pb_selectList[0]
                        let feildPatternParams = val.pattern.params
                        for (let ii in dataValues) {
                            for (let tt in feildPatternParams) {
                                if (ii == feildPatternParams[tt]) {
                                    feildArr.push({key: ii, value: dataValues[ii].value})
                                }
                            }
                        }
                        let params = {
                            gmcUid: this.data.gmcUid,
                            language: this.lang,
                            noEvent: true,
                            lookup: {
                                gmcUid: val.pattern.gmcUid,
                            }
                        }
                        params.feildArr = feildArr
                        this.lookupParams = params;
                        this.$refs.lookupRefs.showModal();
                    }
                    if (val.pattern.custPage == "manual" && val.type == "BUTTON") {
                        if (this.pb_selectList.length < 1) {
                            this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 3)
                            return;
                        }
                        let manualData = this.pb_selectList;
                        let paramsData = [];
                        for (let index in manualData) {
                            if (manualData[index].uid != "") {
                                let paramsObj = {};
                                paramsObj.key = "uid";
                                paramsObj.value = manualData[index].uid;
                                paramsData.push(paramsObj);
                            }
                        }
                        let params = {
                            gmcUid: val.pattern.gmcUid,
                            language: this.lang,
                            params: paramsData,
                            userUid: this.$route.query.userUid
                        };
                        this.manualParams = params;
                        this.$refs.manual.openModal();
                    }
                    if (val.pattern.custPage == "Create Wave" && val.type == "BUTTON") {
                        this.$refs.createWaveRef.open();
                    }
                    if (val.pattern.custPage == "part-de-allocation" && val.type == "BUTTON") {
                        if (this.pb_selectList.length < 1) {
                            this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 3)
                            return;
                        } else {
                            let params = [];
                            for (let ii in this.pb_selectList) {
                                params.push(this.pb_selectList[ii].uid);
                            }
                            ajax.post(api.SOHEADERALLOCAION, { uids: params }).then(res => {
                                if (res.code == 200) {
                                    this.$message.success(res.msg);
                                }
                            });
                        }
                    }
                    if (val.pattern.custPage == "Generate Location" && val.type == "BUTTON") {
                        this.$refs.generateLocationRef.open();
                    }
                    if (val.pattern.custPage == "Batch_Update" && val.type == "BUTTON") {
                        if (this.pb_selectList.length < 1) {
                            this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 3)
                            return;
                        }
                        let Batchdata = this.pb_selectList;
                        let batchDataArr = [];
                        for (let index in Batchdata) {
                            if (Batchdata[index].uid != "") {
                                let paramsObj = {};
                                paramsObj.key = "uid";
                                paramsObj.value = Batchdata[index].uid;
                                batchDataArr.push(paramsObj);
                                batchDataArr.push({
                                    key: "version",
                                    value: Batchdata[index].version
                                });
                            }
                        }
                        this.bathUpdatparams = {
                            gmcUid: val.pattern.gmcUid,
                            language: this.lang,
                            batchDataArr: batchDataArr,
                            btnUid: val.btnUid
                        };
                        this.$refs.bathUpdateRef.open();
                    }
                    if (val.pattern.custPage == "scanpack" && val.type == "BUTTON") {
                        if (this.pb_selectList.length != 1) {
                            this.$customMessage.warning(this.$t('publicLang.pleaseOneOnly'), 3)
                            return;
                        } else {
                            let dataValues = this.pb_selectList[0];
                            this.$refs.scanpackRefs.show(dataValues.uid,this.data.tableList.info);
                        }
                    }
                  if (val.pattern.custPage == "ScanPackPickToZero" && val.type == "BUTTON"){
                    if (this.pb_selectList.length != 1) {
                      this.$message.warning(this.$t('publicLang.pleaseOneOnly'), 3)
                      return;
                    } else {
                      let dataValues = this.pb_selectList[0];
                      this.$refs.scanPackPickToZeroRef.show(dataValues.uid);
                    }
                  }

                    if(val.pattern.custPage == "scanin" && val.type == "BUTTON"){
                        if (this.pb_selectList.length != 1) {
                            this.$customMessage.warning(this.$t('publicLang.pleaseOneOnly'), 3)
                            return;
                        } else {
                            let dataValues = this.pb_selectList[0]
                            this.$refs.scanInRefs.showIn(dataValues.uid,this.data.tableList.info)
                        }

                    }
                    if(val.pattern.custPage == "loading" && val.type == "BUTTON"){
                        this.$refs.loadingRefs.loadingShow()
                    }
                    if(val.pattern.custPage == "adjust" && val.type == "BUTTON"){
                        let params = {}
                        if(this.pb_selectList.length > 0){
                            let arr = []
                            for(let i in this.pb_selectList){
                                arr.push(this.pb_selectList[i].uid)
                            }
                            params.uids = arr
                            params.mark = val.pattern.custPage
                            this.$refs.adjust.show(this.tableGmcuid,params)
                        }else{
                            this.$refs.adjust.show(this.tableGmcuid)
                        }
                    }
                    if(val.pattern.custPage == "Move" && val.type == "BUTTON"){

                        let params = {}
                        if(this.pb_selectList.length > 0){
                            let arr = []
                            for(let i in this.pb_selectList){
                                arr.push(this.pb_selectList[i].uid)
                            }
                            params.uids = arr
                            params.mark = val.pattern.custPage
                            this.$refs.adjustMove.show('Move',params)
                        }else{
                            this.$refs.adjustMove.show('Move')
                        }
                    }
                    if(val.pattern.custPage == "Split" && val.type == "BUTTON"){
                        this.$refs.splitRef.showSplit()
                    }
                    if(val.pattern.custPage == "changeWhProject" && val.type == "BUTTON"){
                        if (this.pb_selectList.length < 1) {
                            this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 3);
                            return;
                        }
                        let uids = [];
                        for (let i in this.pb_selectList) {
                            uids.push(this.pb_selectList[i].uid);
                        }
                        this.$refs.changeWhProjectRef.show(uids, api.SO_VALIDATE_CHANGE_WH_PROJECT, api.SO_CHANGE_WH_PROJECT, 'poNoList');
                    }
                    if(val.pattern.custPage == "deliverydate" && val.type == "BUTTON"){
                        if (this.pb_selectList.length < 1) {
                            this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 3)
                            return;
                        }
                        let deleteData = this.pb_selectList;
                        let paramsData = [];
                        for (let index in deleteData){
                            let paramsObj = {};
                            paramsObj.key = "uid";
                            paramsObj.value = deleteData[index].uid;
                            paramsData.push(paramsObj);
                        }
                        paramsData.push({key: 'moduleName', value: this.data.tableList.info})
                        let tt = {
                            behrUid: '',
                            fieldMapUid: '',
                            functionUid: '',
                            gmcUid: '',
                            language: this.lang,
                            params: paramsData,
                            type: '',
                            userUid: '',
                        }
                       


                           if(this.systemParam.DELIVERY_DATE_NOT_PROMPT == 'Y'){ // 弹出发运确定框
                                    let that = this;
                                    this.$customConfirm({
                                    title: that.$t('publicLang.ConfirmShipment'),
                                    okText: that.$t('publicLang.Confirm'),
                                    cancelText: that.$t('publicLang.Cancel'),
                                    content: "",
                                    onOk() {
                                        ajax.post(api.SOEXTENDERCONFORM,tt).then(res=>{
                                                 if(res.code == 200){

                                                     let uidList = tt.params
                                                         .filter(param => param.key === "uid")  // 筛选出 key 为 "uid" 的参数 Filter out parameters with the key "uid".
                                                         .map(param => param.value);           // 提取 value 值 Extract the value(s)
                                                     if(uidList != undefined && uidList != null && uidList.length > 0) {
                                                         let topMenu = JSON.parse(sessionStorage.getItem("menu"))
                                                         let topMenuActive = sessionStorage.getItem("menuActive")
                                                         for(let i in topMenu){
                                                             if(topMenu[i].key == topMenuActive){
                                                                 let idStr =uidList.join(',');
                                                                 let array =  idStr.split(",")
                                                                 if (array.length <= 100) {
                                                                     //    return true;  // 长度小于100，符合条件
                                                                     topMenu[i].importUids = idStr;
                                                                 }
                                                             }
                                                         }
                                                         sessionStorage.setItem("menu", JSON.stringify(topMenu));
                                                     }


                                                    that.$message.success(res.msg, 3);
                                                     that.init();
                                                 }else{

                                                     that.$customMessage.warning(res.msg);
                                                 }
                                        })

                                    }
                                });
                           }else{      
                                this.$refs.deliveryDate.show(tt)
                           }

                    }
                    if(val.pattern.custPage == 'transfer' && val.type == 'BUTTON'){
                        let uidList = []
                        for(let i in this.pb_selectList){
                            uidList.push(this.pb_selectList[i].uid)
                        }
                        this.$refs.transfer.transferShow(uidList)
                    }
                    if(val.pattern.custPage == 'BatchUpdateShipment' && val.type == 'BUTTON'){
                        if (this.pb_selectList.length < 1) {
                            this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 3)
                            return;
                        }
                        let uidList = []
                        for(let i in this.pb_selectList){
                            uidList.push(this.pb_selectList[i].uid)
                        }
                        let params = {
                            uidList: uidList.join(","),
                            subModuleCode: this.data.tableList.info,
                            gmcUid: this.tableGmcuid,
                            btnGmcUid: val.pattern.gmcUid,
                            btnUid:val.btnUid
                        }
                        this.$refs.batchShipment.show(params)
                    }
                    if(val.pattern.custPage == 'buttonConfig' && val.type == 'BUTTON'){
                        if (this.pb_selectList.length == 1) {
                            this.$refs.buttonConfigRef.show(this.pb_selectList[0].uid)
                        }else{
                            this.$refs.buttonConfigRef.show()
                        }
                    }
                    if(val.pattern.custPage == 'Print-Picking-List' && val.type == 'BUTTON'){
                        if (this.pb_selectList.length != 1) {
                            this.$customMessage.warning(this.$t('publicLang.pleaseOneOnly'), 3)
                            return;
                        }
                        if(this.pb_selectList[0].status == 'New' ||  this.pb_selectList[0].status == 'Cancel' || this.pb_selectList[0].status == 'Delete'){
                            this.$customMessage.warning(this.$t('publicLang.Notprintfirst'))
                            return
                        }
                        let ajaxurl = ajax.ajaxUrl();
                        let params = {
                            name: 'pick_list',
                            soRelId: this.pb_selectList[0].showTitleValue[0]
                        }
                       this.$store.commit("updataLoading", { pbLoading: true });
                        let that = this
                        axios.post(ajaxurl + api.PRINTPREVIEW, params, {
                            headers: {
                                Authorization: cookie.getBearerToken()
                            },
                            responseType: "blob" //二进制流
                        }).then(function(res) {
                            that.pubPdfMsgfn(res)
                        });
                    }
                    if(val.pattern.custPage == 'Print-Packing-List' && val.type == 'BUTTON'){
                        if (this.pb_selectList.length != 1) {
                            this.$customMessage.warning(this.$t('publicLang.pleaseOneOnly'), 3)
                            return;
                        }
                        if(
                            this.pb_selectList[0].status == 'New' ||
                            this.pb_selectList[0].status == 'Cancel' ||
                            this.pb_selectList[0].status == 'Delete' ||
                            this.pb_selectList[0].status == 'Partial Allocated' ||
                            this.pb_selectList[0].status == 'Allocated'
                        ){
                            this.$customMessage.warning(this.$t('publicLang.Notprintpackfirst'))
                            return
                        }
                        let that = this
                        let ajaxurl = ajax.ajaxUrl();
                        let params = {
                            name: 'pack_list',
                            soRelId: this.pb_selectList[0].showTitleValue[0]
                        }
                        this.$store.commit("updataLoading", { pbLoading: true });
                        axios.post(ajaxurl + api.PRINTPREVIEW, params, {
                            headers: {Authorization: cookie.getBearerToken()},
                            responseType: "blob" //二进制流
                        }).then(function(res) {
                            that.pubPdfMsgfn(res)
                         });
                    }
                    //Liyy 2020-07-15 Print Delivery Order报表
                    if(val.pattern.custPage == 'Print-Delivery-Order' && val.type == 'BUTTON'){
                        if (this.pb_selectList.length < 1) {
                            this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 3)//请选择至少一条记录!
                            return;
                        }
                        let sos = "";//SO集合用逗号(,)分开
                        for(let i in this.pb_selectList){
                            // if(this.pb_selectList[i].status != 'Packed'){
                            //     this.$customMessage.warning(this.$t('soPage.PackedFirst'))//不允许打印,请先包装!
                            //     return
                            // }
                            if(sos.length > 0){
                                sos += ",";
                            }
                            sos += this.pb_selectList[i].showTitleValue[0];
                        }
                        let that = this
                        let ajaxurl = ajax.ajaxUrl();
                        let params = {
                            name: 'delivery_order',
                            soRelId: sos,
                        }
                        this.$store.commit("updataLoading", { pbLoading: true });
                        axios.post(ajaxurl + api.PRINTPREVIEW, params, {
                            headers: {Authorization: cookie.getBearerToken()},
                            responseType: "blob" //二进制流
                        }).then(function(res) {
                            that.pubPdfMsgfn(res)
                        });
                    }
                    //Liyy 2020-08-04 Print WineShipmentPackingList报表
                    if(val.pattern.custPage == 'Wine-Shipment-Packing-List' && val.type == 'BUTTON'){
                        if (this.pb_selectList.length < 1) {
                            this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 3)//请选择至少一条记录!
                            return;
                        }
                        let sos = "";//SO集合用逗号(,)分开
                        for(let i in this.pb_selectList){
                            if(this.pb_selectList[i].status == 'Cancelled' || this.pb_selectList[i].status == 'New' || this.pb_selectList[i].status == 'Partially Allocated' || this.pb_selectList[i].status == 'Allocated'){
                                this.$customMessage.warning(this.$t('soPage.PackedFirst'))//不允许打印,请先包装!
                                return
                            }
                            if(sos.length > 0){
                                sos += ",";
                            }
                            sos += this.pb_selectList[i].showTitleValue[0];
                        }
                        let that = this
                        let ajaxurl = ajax.ajaxUrl();
                        let params = {
                            name: 'WineShipmentPackingList',
                            soRelId: sos,
                        }
                        this.$store.commit("updataLoading", { pbLoading: true });
                        axios.post(ajaxurl + api.PRINTPREVIEW, params, {
                            headers: {Authorization: cookie.getBearerToken()},
                            responseType: "blob" //二进制流
                        }).then(function(res) {
                            that.pubPdfMsgfn(res)
                        });
                    }
                    //Liyy 2020-08-04 Print WinePickingList报表
                    if(val.pattern.custPage == 'Wine-Picking-List' && val.type == 'BUTTON'){
                        if (this.pb_selectList.length < 1) {
                            this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 3)//请选择至少一条记录!
                            return;
                        }
                        let sos = "";//SO集合用逗号(,)分开
                        for(let i in this.pb_selectList){
                            if(this.pb_selectList[i].status == 'New'){
                                this.$customMessage.warning(this.$t('publicLang.StatusNotNew'))//不能选择新建状态的订单
                                return
                            }
                            if(sos.length > 0){
                                sos += ",";
                            }
                            sos += this.pb_selectList[i].showTitleValue[0];
                        }
                        let that = this
                        let ajaxurl = ajax.ajaxUrl();
                        let params = {
                            name: 'WinePickingList',
                            soRelId: sos,
                        }
                        this.$store.commit("updataLoading", { pbLoading: true });
                        axios.post(ajaxurl + api.PRINTPREVIEW, params, {
                            headers: {Authorization: cookie.getBearerToken()},
                            responseType: "blob" //二进制流
                        }).then(function(res) {
                            that.pubPdfMsgfn(res)
                        });
                    }
                    if(val.pattern.custPage == 'ShipmentMaintenance' && val.type == 'BUTTON'){
                        let columns = this.data.tableList.columns
                        let relIdGmdUid = 0;
                        for(let i in columns){
                            let  column =  columns[i];
                            if(column.flag != null && column.flag.toUpperCase() == 'REL_ID') {
                                relIdGmdUid = column.uid
                            }else{
                                continue;
                            }
                        }
                        let sos = "";//SO集合用逗号(,)分开
                        for(let i in this.pb_selectList){
                            if(sos.length > 0){
                                sos += ",";
                            }
                            let row =  this.pb_selectList[i];
                            sos += row[relIdGmdUid].value;
                        }
                        this.$refs.refShipmentMaintenance.show(sos)
                    }
                    if(val.pattern.custPage == 'liquor' && val.type == 'BUTTON'){
                        ajax.get(api.GETORDERBYINVENTORYDATA).then(res => { //根据Project配置的OrderModel选择弹出Wine的"Order By Inventory"还是新的Non-Mer
                            let orderByInventoryData = res.data;
                            if(orderByInventoryData.orderMode == 'NON_MER'){
                                this.$refs.nonMerMailRef.show(orderByInventoryData);
                            }else{
                                this.$refs.liquorStepRef.show()
                            }
                        });
                    }
                }
            },
			waveCancelOrClosePop(val){
                this.addSoToWaveRelIdList = [];
                this.addSoToWaveVisible = false;
                  if (val == "init") {
                    this.init();
                }
            },

            GETcancelImport(val) {
                this.importVisible = false;
                this.getTemplateName()
                if (val == "init") {
                    this.init("empty_temp")
                }
            },
            getBtnConfigemit(){
                this.init();
            },
            GETcancelModalVisible(val) {
                this.eddvisible = false;
                this.getTemplateName()
                if (val != "close") {
                    this.init("empty_temp")
                }
            },
            getdeliverdate(){
                this.init();
            },
            getMoveSave(){
                this.initRenderFn()
            },

            previewHttpFile(url) {
                let ajaxurl = ajax.ajaxUrl();
                let previewUrl = ajaxurl + "/printViewFile?filePath=" + url;
                window.open(previewUrl, '_blank');
            },

            previewHttpFiles(urls) {
                for (const url of urls) {
                    let ajaxurl = ajax.ajaxUrl();
                    let previewUrl = ajaxurl + "/printViewFile?filePath=" + url;
                    window.open(previewUrl, '_blank');
                }
            },

            printPreview(tt,val){
                let ajaxurl = ajax.ajaxUrl();
                let that = this;
                this.isBtnajax = true
                console.log("print---start" + tt.toString());
                console.log("print---start" + tt.length);
                axios.post(ajaxurl + api.PRINTPREVIEW, {
                        gmcUid: this.tableGmcuid,
                        uid: tt.toString(),
                        btnName: val.name,
                        btnUid: val.btnUid
                    }, {
                    headers: {
                        Authorization: cookie.getBearerToken()
                    },
                    responseType: "blob" //二进制流
                }).then(function (res) {
                    let resHeader = res.headers;
                    let contentType = resHeader["content-type"];
                    let excelContentType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8";
                    if (excelContentType.indexOf(contentType) != -1) {
                        //excel
                        that.isBtnajax = false
                        var data = res;
                        if (!data) {
                            return;
                        }
                        var blob = new Blob([data.data], {
                            type:
                                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
                        });
                        var url = window.URL.createObjectURL(blob);
                        var aLink = document.createElement("a");
                        aLink.style.display = "none";
                        aLink.href = url;
                        aLink.setAttribute("download", "excel.xlsx");
                        document.body.appendChild(aLink);
                        aLink.click();
                        document.body.removeChild(aLink); //下载完成移除元素
                        window.URL.revokeObjectURL(url); //释放掉blob对象
                    } else {
                        //pdf
                        that.pubPdfMsgfn(res);
                    }
                });
            },
            // 异步请求
            async batchExportReportByExcels(params, shipmentMap, val, ajaxurl){
                const shipmentNoMap = shipmentMap['shipmentNoMap'];
                let arr = [];
                for(let key in shipmentNoMap) {
                    let relIdsList = shipmentNoMap[key];
                    let paramsDataNow = [];
                    let shipmentParams = {};
                    shipmentParams.key = "shipmentNo";
                    shipmentParams.value = key;
                    paramsDataNow.push(shipmentParams);
                    for (let index in relIdsList) {
                        let paramsObj = {};
                        paramsObj.key = "relId";
                        paramsObj.value = relIdsList[index];
                        paramsDataNow.push(paramsObj);
                    }
                    let paramsNow = {
                        behrUid: val.btnUid,
                        userUid: this.$route.query.userUid,
                        functionUid: this.$route.query.funcUid,
                        gmcUid: val.pattern.gmcUid,
                        params: paramsDataNow,
                        language: this.lang
                    };
                    arr.push(ajax.exportExcel(ajaxurl + val.externalApi, paramsNow));
                }
                const res = await Promise.all(arr);
                return res;
            },

            initByStatus(soStatus) {
                this.clearConditionQuery();

                if("searchSinglePieceOrder" == soStatus) {
                    this.filterOneSkuOneQtyOrderFlag = true;
                    this.orderStatus = "00";
                } else {
                    this.orderStatus = soStatus;
                }
                this.pageInfoType = "qf";
                this.currentVal = 1;
                this.initRenderFn();
            },
            clearConditionQuery(){//使用Title Search或高级查询时,需清空左侧查询条件
                this.queryByCondition = false
                this.conditionList = []
                this.$refs.refConditionQuery.resetQuery();
                this.initRenderFnSearchParamsArr.titleSearchArr = []
                let jsonArray = {};
                jsonArray.gmcUid = this.tableGmcuid;
                this.initRenderFnSearchParamsArr.andvanSearchArr = jsonArray;
            },
        }
    };
</script>
<style lang="less">
    @import "../../assets/css/bootstrap.css";
    #queryBuilder {
        overflow: hidden;
    }
    .queryBtnSty {
        margin: 4px 0;
    }
    #skuPage {
        background: #fff;
        overflow: hidden;
        .skupage {
            overflow: hidden;
            overflow-y: auto;
        }
        .ant-collapse-content > .ant-collapse-content-box {
            padding: 0;
        }
    }
    .ant-drawer-body {
        padding: 2px;
    }
    .statusButton {
        margin: 0 3px;
        height: 30px;
        width: auto;
        background-color: #ffffff;
        font-weight: 600;
    }


</style>
